<template>
  <div v-if="filtered">
    <v-data-table
      :headers="headers"
      :items="teacherAttendances"
      :server-items-length="teacherAttendanceCount"
      :options.sync="tableOptions"
      item-key="id"
      :footer-props="tableFooterOptions"
      :loading="loading"
      loading-text="Đang Tải"
      disable-sort
    >
      <template v-slot:[`item.teacher.name`]="{ item }">
        <CardTeacherName :teacher="item.teacher" link />
      </template>
      <template v-slot:[`item.teacher.dob`]="{ item }">
        {{ item.teacher.dob | ddmmyyyy }}
      </template>
      <template v-slot:[`item.`]="{ item }">
        {{ item.teacher.dob | ddmmyyyy }}
      </template>
      <template v-slot:[`item.subjectGroup`]="{ item }">
        {{ item | _get('subjectGroup.title', 'Chưa có') }}
      </template>
      <template v-slot:[`item.time`]="{ item }">
        <div v-if="item.teacherCheckins && item.teacherCheckins.length">
          <div
            class="pt-2"
            style="height: 36px"
            v-for="teacherCheckin in item.teacherCheckins"
            :key="teacherCheckin.id"
          >
            {{ teacherCheckin.checkIn | hhmm }} / {{ teacherCheckin.checkOut | hhmm }}
            <v-icon small right @click="openEditDialog(item, teacherCheckin)">mdi-pencil</v-icon>
          </div>
        </div>
        <div v-else>--:-- / --:-- <v-icon small right @click="openEditDialog(item, {})">mdi-pencil</v-icon></div>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <div v-if="item.teacherCheckins && item.teacherCheckins.length">
          <div
            v-for="teacherCheckin in item.teacherCheckins"
            :key="teacherCheckin.id"
            class="pt-2"
            style="height: 36px"
          >
            <v-chip small label :color="teacherCheckin.status | getAttendanceStatusColor" dark>
              <span>
                {{ teacherCheckin.status | getAttendanceStatus }}
              </span>
            </v-chip>
          </div>
        </div>
        <div v-else>
          <v-chip small label color="#FD6B6B" dark>
            <span> Chưa điểm danh </span>
          </v-chip>
        </div>
      </template>
    </v-data-table>
    <EditTeacherAttendanceDialog
      :selectedTeacherAttendance="selectedTeacherAttendance"
      :selectedTeacherCheckin="selectedTeacherCheckin"
      :state="editDialog"
    />
  </div>
  <div v-else class="d-flex flex-column align-center justify-center mx-md-4 my-md-4 elevation-0 py-16">
    Vui lòng cung cấp các thông tin ở trên, sau đó ấn [Tìm kiếm] để kiểm tra trạng thái điểm danh
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import utils from '@/plugins/utils'
import moment from 'moment'
import CardTeacherName from '../../../components/basic/card/CardTeacherName.vue'
import EditTeacherAttendanceDialog from './EditTeacherAttendanceDialog.vue'

const originHeaders = [
  { text: 'Giáo viên', value: 'teacher.name' },
  { text: 'Ngày sinh', value: 'teacher.dob' },
  { text: 'Chuyên môn', value: 'subjectGroup' },
  { text: 'Giờ đến / Giờ về', value: 'time' },
  { text: 'Trạng thái', value: 'status' },
]
export default {
  components: {
    CardTeacherName,
    EditTeacherAttendanceDialog,
  },
  data() {
    return {
      headers: originHeaders,
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      teacherAttendanceCount: 0,
      selectedTeacherCheckin: {},
      selectedTeacherAttendance: {},
      editDialog: true,
      filtered: true,
      loading: false,
      teacherAttendanceSearchParams: {},
    }
  },
  computed: {
    ...mapState('teacherAttendance', ['teacherAttendances']),
    tableFooterOptions() {
      let footerOptions = {
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': this.tableOptions.itemsPerPage,
        'page-text': utils.paginationText(this.tableOptions, this.teacherAttendanceCount),
        itemsPerPageOptions: [10, 20, 40, 100],
      }
      return footerOptions
    },
  },
  methods: {
    ...mapActions('teacherAttendance', ['getTeacherAttendances', 'getTeacherAttendanceCount']),
    async searchTeacherAttendances(teacherAttendanceFilters) {
      this.filtered = true
      this.loading = true
      if (teacherAttendanceFilters) {
        let attendanceParams = {}
        if (teacherAttendanceFilters.teacher || teacherAttendanceFilters.status) {
          attendanceParams.teacher = teacherAttendanceFilters.teacher
          attendanceParams.status = teacherAttendanceFilters.status
        } else {
          if (teacherAttendanceFilters.subjectGroup) {
            attendanceParams.subjectGroup = teacherAttendanceFilters.subjectGroup
          }
          if (teacherAttendanceFilters.teacherType) {
            attendanceParams.teacherType = teacherAttendanceFilters.teacherType
          }
          if (teacherAttendanceFilters.academicLevels_in) {
            attendanceParams.academicLevels_in = teacherAttendanceFilters.academicLevels_in
          }
        }
        if (teacherAttendanceFilters.date) {
          attendanceParams = {
            ...attendanceParams,
            date_gte: moment(teacherAttendanceFilters.date).startOf('day').toISOString(),
            date_lte: moment(teacherAttendanceFilters.date).endOf('day').toISOString(),
          }
        }
        try {
          this.teacherAttendanceCount = await this.getTeacherAttendanceCount(attendanceParams)
        } catch (error) {
          this.$alert.error('Không lấy được số lượng điểm danh. Lỗi: ' + error)
        }
        this.tableOptions.page = 1
        this.teacherAttendanceSearchParams = { ...attendanceParams, ...this.pageSetting() }
      } else {
        this.teacherAttendanceSearchParams = { ...this.teacherAttendanceSearchParams, ...this.pageSetting() }
      }
      try {
        await this.getTeacherAttendances({ searchParams: this.teacherAttendanceSearchParams })
      } catch (error) {
        this.$alert.error('Không lấy được danh sách điểm danh. Lỗi : ', error)
      }
      this.loading = false
    },
    pageSetting() {
      return {
        _start: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
        _limit: this.tableOptions.itemsPerPage,
        _sort: 'teacherNameToNumber:ASC',
      }
    },
    async openEditDialog(teacherAttendance, teacherCheckin) {
      this.selectedTeacherAttendance = teacherAttendance
      this.selectedTeacherCheckin = teacherCheckin
      this.$nextTick(() => {
        this.editDialog = !this.editDialog
      })
    },
  },

  watch: {
    tableOptions: {
      async handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (itemPerPageChanged || pageChanged) {
          await this.getTeacherAttendances({
            searchParams: {
              ...this.teacherAttendanceSearchParams,
              _start: (newOptions.page - 1) * newOptions.itemsPerPage,
              _limit: newOptions.itemsPerPage,
            },
          })
        }
      },
      deep: true,
    },
  },
}
</script>
